import { render, staticRenderFns } from "./categories.vue?vue&type=template&id=707dfe05&scoped=true"
import script from "./categories.vue?vue&type=script&lang=js"
export * from "./categories.vue?vue&type=script&lang=js"
import style0 from "./categories.vue?vue&type=style&index=0&id=707dfe05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707dfe05",
  null
  
)

export default component.exports